'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { ApiAccommodation, ApiShip } from '../../../api/model';
import { ApiProduct } from '../../../api/model';
import type { PartialPageProps } from '@/types/cms/magnolia';

const AccommodationContent = dynamic(
  () => import('@/components/accommodations/AccommodationContent')
);

const AccommodationContentClientImporter: FC<{
  accommodation?: Partial<Omit<ApiAccommodation, 'relatedShip'>> & {
    relatedShip?: Partial<ApiShip>;
  };
  className?: string;
  simpleMode?: boolean;
  pageProps?: PartialPageProps;
}> = (props): JSX.Element => {
  return <AccommodationContent {...props} />;
};

export default AccommodationContentClientImporter;
